import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MedicalAppointmentCancelReason, MedicalAppointmentCancel } from '../../../model/medical-appointment-cancel';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { ReservationService } from '../../../services/reservation.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'dialog-medical-appointment-cancel-component',
  templateUrl: 'dialog-medical-appointment-cancel.component.html',
  styleUrls: ['./dialog-medical-appointment-cancel.component.css']
})
export class DialogCancelMedicalAppointmentComponent implements OnInit {
  cancelDialogForm: FormGroup;
  medicalAppointmentCancelReasons: MedicalAppointmentCancelReason[] = [];
  medicalAppointmentCancelReason: MedicalAppointmentCancelReason;

  constructor(
    public dialogRef: MatDialogRef<DialogCancelMedicalAppointmentComponent>,
    private reservationService: ReservationService
    , private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , @Inject(MAT_DIALOG_DATA) public data: any) {

    this.cancelDialogForm = this.formBuilder.group({
      Observations: [''],
      MedicalAppointmentCancelReason: [null, Validators.required],
      MedicalAppointmentIds: [this.data.medicalAppointmentIds],
    });
  }

  get f() { return this.cancelDialogForm.controls; }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async save() {
    try {
      if (!this.cancelDialogForm.invalid) {
        const medicalAppointmentCancel = <MedicalAppointmentCancel>this.cancelDialogForm.getRawValue();
        medicalAppointmentCancel.MedicalAppointmentIds = this.data.medicalAppointmentIds;
        if (await this.reservationService.cancelMedicalAppointment(medicalAppointmentCancel)) {
          if (medicalAppointmentCancel.MedicalAppointmentIds.length > 1) {
            this.notificationToastService.success('Se cancelaron los turnos correctamente', 'Cancelación de turno');
          } else {
            this.notificationToastService.success('Se canceló el turno correctamente', 'Cancelación de turno');
          }
          this.dialogRef.close(true);
        }
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Cancelación de turno');
    }
  }

  async ngOnInit() {
    try {
      this.medicalAppointmentCancelReasons = await this.reservationService.getMedicalAppointmentCancelReasons();
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Cancelación de turno');
    }
  }
}
